const STORAGE_PREFIX = 'vibe_iot_';

export const storage = {
  get: <T>(key: string, defaultValue?: T): T | null => {
    try {
      const item = window.localStorage.getItem(`${STORAGE_PREFIX}${key}`);
      return item ? JSON.parse(item) : defaultValue ?? null;
    } catch (error) {
      console.error(`Error reading from localStorage key ${key}:`, error);
      return defaultValue ?? null;
    }
  },

  set: <T>(key: string, value: T): boolean => {
    try {
      window.localStorage.setItem(`${STORAGE_PREFIX}${key}`, JSON.stringify(value));
      return true;
    } catch (error) {
      console.error(`Error writing to localStorage key ${key}:`, error);
      return false;
    }
  },

  remove: (key: string): boolean => {
    try {
      window.localStorage.removeItem(`${STORAGE_PREFIX}${key}`);
      return true;
    } catch (error) {
      console.error(`Error removing localStorage key ${key}:`, error);
      return false;
    }
  },

  clear: (): boolean => {
    try {
      const keys = Object.keys(window.localStorage);
      keys.forEach(key => {
        if (key.startsWith(STORAGE_PREFIX)) {
          window.localStorage.removeItem(key);
        }
      });
      return true;
    } catch (error) {
      console.error('Error clearing localStorage:', error);
      return false;
    }
  },
};

export const deviceTabStorage = {
  getTabIndex: (deviceId: string): number => {
    return storage.get<number>(`device_tab_${deviceId}`, 0) ?? 0;
  },

  setTabIndex: (deviceId: string, tabIndex: number): void => {
    storage.set(`device_tab_${deviceId}`, tabIndex);
  },

  clearTabIndex: (deviceId: string): void => {
    storage.remove(`device_tab_${deviceId}`);
  },
};
